import { DateTime } from 'luxon';

const getLocalTime = (localTimezone: string) =>
  DateTime.local().setZone(localTimezone).toFormat('ZZ');

export const getTimezoneText = (localTimezone: string) =>
  localTimezone
    ? `Your timezone is ${localTimezone} (UTC ${getLocalTime(localTimezone)})`
    : 'No timezone set';
